<template>
  	<div class="animated fadeIn">
		<b-row>
		    <b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-align-justify"></i><strong> {{$trans['general']['censuses']}} 2011</strong> <small v-if="!loading1"> - {{item1.name}}, {{item1.district.name}}</small>
			        </div>
			        <div>
						<b-row>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<b-form-group :label="$trans[$route.meta.trans_key]['county']" label-for="sel-county">
											<b-form-select id="sel-county" v-model="id_item_selected">
												<option v-for="item in all_items1" :key="item.id" :value="item.id">{{item.name}}, {{item.district.name}}</option>
											</b-form-select>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div :class="(!loading1) ? 'has_data' : 'card-loader-container'">
									<loader v-if="loading1"></loader> 
									<b-card>
										<h4 class="card-title">{{$trans['general']['censuses']}} 2011 - {{$trans[$route.meta.trans_key]['resident_population']}} <span v-on:click="modal_active = true" class="fa fa-info-circle cursor-pointer font-12 v-align-top"></span></h4>
										<b-list-group>
											<b-list-group-item v-for="(item, idx) in all_items2" :key="idx">
												<b>{{item.name}}:</b> {{item.population}} ({{item.pop_density}} Hab/km<sup>2</sup>)
											</b-list-group-item>
										</b-list-group>
									</b-card>
								</div>
							</b-col>
						</b-row>
			        </div>
			    </b-card>
			</b-col>
		</b-row>
		<modal v-if="modal_active" v-on:close="modal_active = false">
			<p slot="body" v-html="$trans[$route.meta.trans_key]['disclaimer'].replace('{assets_url}', assets_url)"></p>
		</modal>
	</div>
</template>
<script>
export default {
	name: 'Demo_Fregs',
	data() {
		return {
			disclaimer_active: null,
			modal_active: false,
			all_items1: [],
			all_items2: [],
			item_details: {},
			id_item_selected: this.$route.params.id,
			loading1: true,
		}
	},
	methods: {
		get_censos_data: function() {
			const that = this;
			that.get_req('concelho/' +that.id_item_selected+ '/freguesias/last_censos',
				function() { // before
					that.loading1 = true;
	            },
				function(response) { // success
					that.all_items2 = response.body;
					that.loading1 = false;
				},
				function(response) { // fail
					alert('ajax main.js error: '+ response.status);
				},
				function(response) {
					
				});
		},
		init_comp: function() {
			if(this.globs['counties'] !== null) {
				this.all_items1 = this.globs['counties'];
				this.id_item_selected = this.get_starter_item(this.globs['counties'], this.id_item_selected).id;
				return;
			}
			const that = this;
			that.get_req('freguesias/counties/all',
				function() { // before
					//that.loading = true;
	            },
				function(response) { // success
					that.all_items1 = response.body;
					that.globs['counties'] = that.all_items1;
					that.id_item_selected = that.get_starter_item(that.all_items1, that.id_item_selected).id;
				},
				function(response) { // fail
					alert('ajax main.js error: '+ response.status);
				},
				function(response) {
					
				});
		},
	},
	watch: {
		id_item_selected: function(new_val, old_val) {
			this.item_details = this.all_items1.find((item) => item.id == this.id_item_selected);
			this.get_censos_data();
		},
		'$route.params.id': function(new_val, old_val) {
			if(typeof new_val === 'undefined') { //back button porpuses
				this.$router.go(-1);
			}
			else if(this.id_item_selected != new_val) {
				this.id_item_selected = new_val;
			}
		},
		item_details: function(new_val, old_val) {
			this.$router.push({name: 'Demographic_Fregs', params: {lang: this.$lang, id: this.id_item_selected, slug: new_val.slug}});
		}
	},
	computed: {
		item1: function() {
			return this.all_items1.find((item) => item.id == this.id_item_selected);
		}
	},
	created: function() {
		this.init_comp();
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.local-badge {
	width: 160px;
}

/*.censos_chart {
  background: #212733;
  border-radius: 15px;
  box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27);
  
}

.censos_chart h2 {
  margin-top: 0;
  padding: 15px 0;
  color:  rgba(255, 0,0, 0.5);
  border-bottom: 1px solid #323d54;
}*/
</style>